import { getEnvVariable } from "../../../modules/environmentalList"
//import notehistory from './notehistorygrid';
const EditAnnouncements = {
    "type": "popup",
    "key": "EditAnnouncements",
    "name": "EditAnnouncements",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'editOpen'
    },
    sharedValues: ['open'],
    container: {
        closepopup: true,
        closepopupval: 'announcements',
        "addRoute": true,
        "routeParams": { replace: 'announcements', param: 'Id', routeName: 'id' },
        'removelayout': 'EditAnnouncements',
        values: { editInfo: null, edit: false, createduplicate: false, fullscreen: false, back: false, allgriddata: null, navigation: null },
        mapValues: {
            header: [
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
                { key: 'allgriddata', name: 'allgriddata' },
            ],
            ViewAnnouncements: [
                { key: 'editInfo', name: 'editInfo' },
                { key: 'allgriddata', name: 'allgriddata' },
                { key: 'save', name: 'save' },
                { key: 'saveduplicate', name: 'saveduplicate' },
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
                { key: 'back', name: 'back' },
                { key: 'navigation', name: 'navigation' },]
        },
        //  sharedValues: ['save', 'edit'],
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: '',
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12 px-1',
                    sub: {
                        type: 'div',
                        className: 'col-12 px-1',
                    }
                }],

            },


            {
                order: 1,
                type: 'div',
                className: 'row m-1 application-border',
                components: [{
                    name: 'ViewAnnouncements',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },
            ]
        },

        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'Announcements',
                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "View/Edit Announcements", "materialicon": "campaign", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                        title: 'Back'
                    },

                    {
                        type: 'icon',
                        icon: 'edit',
                        name: 'edit',
                        hideon: 'createduplicate',
                        hideanother: 'edit',
                        hidevalue: true,
                        title: 'Edit',
                        //hideconditionvalue:true
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        name: 'save',
                        hideon: 'edit',
                        hidevalue: false,
                        title: 'Save'
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        name: 'saveduplicate',
                        hideon: 'createduplicate',
                        hidevalue: false,
                        title: 'Save'
                    },
                    {
                        type: 'icon',
                        icon: 'previtem',
                        name: 'previtem',
                        hideon: 'previtem',
                        hidevalue: false,
                        title: 'Previous Item'
                    },
                    {
                        type: 'icon',
                        icon: 'nextitem',
                        name: 'nextitem',
                        hideon: 'nextitem',
                        hidevalue: false,
                        title: 'Next Item'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hidevalue: false,
                        title: 'Full Screen'
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false,
                        title: 'Exit Full Screen'
                    },
                    {
                        type: 'icon',
                        icon: 'history',
                        name: 'history',
                        title: 'History',
                        hideon: 'history',
                        hidevalue: false,
                        historyurl: {
                            title : 'Announcements History',
                            url: getEnvVariable('Admin') + `/api/Announcements/history/{Id}?`,
                            "routeProps": [{ name: "id", key: "Id", },],
                            type: 'get',
                            saveAs: { key: 'data' }
                        }
                    },
                ],
            },
            ViewAnnouncements: {
                "type": "form",
                initRun: true,
                "key": "ViewAnnouncements",
                "name": "ViewAnnouncements",
                aliases: {
                    'editInfo': 'editInfo',
                    'allgriddata': 'allgriddata',
                    'navigateItem': 'navigateItem',
                    'edit': 'edit'
                },
                sharedValues: ['editInfo', 'allgriddata', 'navigateItem', 'navigation', 'edit', 'save', 'createduplicate', 'exitfullscreen', 'fullscreen', 'back'],
                validationMapKeys: [],
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Subject',
                                type: 'div',
                                className: 'col-10',
                                sub: {
                                    type: 'div',
                                    className: 'col-10',
                                }
                            },

                            ]
                        },
                        {
                            order: 1,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'Body',
                                    type: 'div',
                                    className: 'col-10',
                                    sub: {
                                        type: 'div',
                                        className: 'col-10',
                                    }
                                },
                            ]
                        },
                        {
                            order: 2,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'ViewerAccess',
                                type: 'div',
                                className: 'col-10',
                                sub: {
                                    type: 'div',
                                    className: 'col-10',
                                }
                            }]
                        },
                        {
                            order: 3,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Status',
                                type: 'div',
                                className: 'col-10 pl-4 ml-3 mt-3',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 pl-4 ml-3 mt-3',
                                }
                            }]
                        },
                        {
                            order: 3,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'CreatedOn',
                                type: 'div',
                                className: 'col-5',
                                sub: {
                                    type: 'div',
                                    className: 'col-5',
                                }
                            },
                            {
                                name: 'CreatedByName',
                                type: 'div',
                                className: 'col-5',
                                sub: {
                                    type: 'div',
                                    className: 'col-5',
                                }
                            },
                            ]
                        },
                        {
                            order: 4,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'UpdatedOn',
                                    type: 'div',
                                    className: 'col-5',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5',
                                    }
                                },
                                {
                                    name: 'UpdatedByName',
                                    type: 'div',
                                    className: 'col-5',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5',
                                    }
                                },]
                        },
                    ]

                },
                values: {
                    Subject: '',
                    Body: '',
                    ViewerAccess: '',
                    Status: '',
                    UpdatedByName: '',
                    CreatedByName: '',
                    UpdatedOn: '',
                    CreatedOn: '',
                    UpdatedBy: '',
                    CreatedBy: '',
                    Id: '',
                    editInfo: null,
                    allgriddata: null,
                    navigation: null,
                    portal: getEnvVariable('AccessPortal'),
                },
                "components": {
                    Subject: {
                        "type": "label",
                        "key": "Subject",
                        "label": "Subject",
                        "name": "Subject",
                        changefieldto: "textfield",
                    },
                    Body: {
                        "type": "editor",
                        "key": "Body",
                        "label": "Body",
                        "name": "Body",
                        "multiline": true,
                        rowsMax: "5",
                        "rows": 6,
                        changefieldto: "editor",
                    },
                    ViewerAccess: {
                        "type": "label",
                        "key": "ViewerAccess",
                        "label": "Viewer Access",
                        name: "ViewerAccess",
                        changefieldto: "radiogroup",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value',
                            },
                        },
                        items: [{ value: 'I', name: 'Internal' }, { value: 'E', name: 'External' }, { value: 'B', name: 'Both' }],
                    },
                    Status: {
                        "type": "label",
                        "key": "Status",
                        "label": "Status",
                        "name": "Status",
                        changefieldto: "toggle",
                        extraProps: {
                            "transformProps": {
                                "A": true,
                                "I": false,
                                "true": "A",
                                "false": "I"
                            }
                        }
                    },
                    CreatedOn: {
                        "type": "label",
                        "key": "CreatedOn",
                        "label": "Created On",
                        name: "CreatedOn",
                        changefieldto: "label",
                    },
                    CreatedByName: {
                        "type": "label",
                        "key": "CreatedByName",
                        "label": "Created By",
                        name: "CreatedByName",
                        changefieldto: "label",
                    },
                    UpdatedOn: {
                        "type": "label",
                        "key": "UpdatedOn",
                        "label": "Updated On",
                        name: "UpdatedOn",
                        changefieldto: "label",
                    },
                    UpdatedByName: {
                        "type": "label",
                        "key": "UpdatedByName",
                        "label": "Updated By",
                        name: "UpdatedByName",
                        changefieldto: "label",
                    },
                },
                mapActionsToEffects: {
                    'onChange': {
                        'navigation': {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'initial', //http://development.delasoft.com:8443/AMES-application/api/ProposedLandUse/5864/Add
                                            "read": [
                                                {
                                                    url: getEnvVariable('Admin') + `/api/Announcements/{Id}`,
                                                    key: 'save',
                                                    "matchProps": [
                                                        {
                                                            name: "navigation.Id",
                                                            key: "Id",
                                                        }
                                                    ],
                                                    type: 'get',
                                                }
                                            ]
                                        },
                                    ]
                                }
                            }]
                        },
                        'edit': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'edit',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'exitfullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'exitfullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'fullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'fullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'createduplicate': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'createduplicate',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    },
                    'afterSave': {
                        'saveduplicate': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'save',
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin')+`/api/Announcements/Add`,
                                                        type: 'post',
                                                        "matchProps": [{
                                                            name: "routeid1",
                                                            key: "routeid1",
                                                        }]
                                                    }
                                                ],
                                            },

                                        ]
                                    }
                                }
                            ]
                        },

                        'save': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'save',// http://development.delasoft.com:8443/${getEnvVariable('ModuleKey')}-application/api/Property/23123/Add
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin') + `/api/Announcements/Update`,
                                                        type: 'put',
                                                        "matchProps": [{
                                                            name: "routeid1",
                                                            key: "routeid1",
                                                        },
                                                        {
                                                            name: "Id",
                                                            key: "Id",
                                                        }
                                                        ]
                                                    }
                                                ],
                                            },
                                            {
                                                type: 'value',
                                                key: 'editOpen',
                                                result: false
                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    },

                }
            }
        },

    }
}

export default EditAnnouncements;
